import { useEffect, useRef, useState } from "react"
import useWindowResize from "../hooks/useWindowResize";
import { calculateAlignClasses } from "../utils/utilities";

export default function Drawer({ isOpen, close = null, children, type = 'drawer' }) {

    const drawerRef = useRef(null)
    const [alignClasses, setAlignClasses] = useState({
        top: 0,
        left: 0,
        bottom: 'auto',
        right: 'auto',
        position: type === "drawer" ? 'fixed' : 'absolute'
    })

    const handleBackdropClick = () => {
        if (type === 'popover' && close) {
            close()
        }
    }

    useWindowResize(reCalculateAlignClasses)

    useEffect(() => {
        document.body.style.overflow = isOpen ? 'hidden' : 'auto'
        document.getElementById('site-content').style.zIndex = isOpen ? '999' : '1'
        reCalculateAlignClasses()
    }, [isOpen]);

    function reCalculateAlignClasses() {
        if (isOpen && type === 'popover' && drawerRef.current) {
            setAlignClasses(calculateAlignClasses(drawerRef.current.getBoundingClientRect(), window.innerHeight, window.innerWidth))
        }
    }

    const drawerClasses = {
        drawer: 'h-screen w-screen',
        popover: 'h-fit w-fit shadow-2xl max-w-[calc(100vw-32px)] max-h-[calc(100vh-32px)]'
    }

    return (
        <>
            <div className={`${isOpen ? 'block' : 'hidden'} fixed w-screen h-screen inset-0 bg-transparent z-[1300]`} onClick={handleBackdropClick}></div>
            <div
                role={'presentation'}
                ref={drawerRef}
                style={{...alignClasses}}
                onClick={(e) => e.stopPropagation()}
                className={`${isOpen ? 'block' : 'hidden -translate-x-full'} ${drawerClasses[type] || drawerClasses.drawer} box-border
                z-[1300] p-4 pointer-events-none overflow-y-scroll transition-transform bg-white`}>
                <div className={'relative pointer-events-auto p-4'}>
                    { children }
                </div>
            </div>
        </>
    )
}